import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import buscarTodasAdesoesPontos from '../../actions/adesao-pontos/buscarTodasAdesoesPontos';
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN } from '../../security/securityContext';
import AdesaoPonto from './AdesaoPonto';

export class PainelGerenciarAdesaoPontos extends Component {

    componentDidMount() {
        this.props.buscarTodasAdesoesPontos();
    }

    exibirConteudo() {
        const { adesaoPontos } = this.props;

        if (!adesaoPontos || adesaoPontos.length === 0) {
            return (
                <div className="vx-empty-state">
                    <i className="material-icons">stars</i>
                    <p>Nenhuma configuração de pontos cadastrada.</p>
                </div>
            );
        }

        return (
            <div className="vx-table-scroll">
                <table className="vx-table-left">
                    <thead>
                        <tr>
                            <th>Empresa</th>
                            <th>Peso</th>
                            <th>Pontos</th>
                            <th>Geração de Pontos</th>
                            <th>Consumo de Pontos</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {adesaoPontos.map(it => (
                            <AdesaoPonto key={`adesao-pontos-${it.id}`} adesaoPonto={it} />
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className="container-padrao">
                    <Titulo texto="Gestão de Pontos" urlRetorno="/menu-adesao-pontos" />
                    <div className="vx-table-card">
                        {this.exibirConteudo()}
                    </div>
                </div>
            </Autorizacao>
        );
    }
}

export function mapStateToProps(state) {
    return {
        adesaoPontos: state.adesaoPontos,
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication,
    };
}

export default withRouter(connect(mapStateToProps, {
    buscarTodasAdesoesPontos,
})(PainelGerenciarAdesaoPontos));
